'use strict';

export function createHorse(options) {

    if (!options.quickCreate) {options.quickCreate = false;};
    if (!options.horseSexId) {options.horseSexId = '';};
    if (!options.isPedigree) {options.isPedigree = false;};
    if (!options.hidePedigreeOption) {options.hidePedigreeOption = false;};
    if (!options.fOnSelect) {options.fOnSelect = '';};
    if (!options.ids) {options.ids = '';};
    if (!options.cellPos) {options.cellPos = '';};
    if (!options.title) {options.title = 'Horse Search & Import';};

    var popURL = '/pages/arion_import.cfm?' + jQuery.param({
        'quickCreate': options.quickCreate,
        'horseSexId': options.horseSexId,
        'isPedigree': options.isPedigree,
        'hidePedigreeOption': options.hidePedigreeOption,
        'fOnSelect': options.fOnSelect,
        'ids': options.ids,
        'cellPos': options.cellPos,
    });

    popWin({
        popID: 'arion_import',
        title: options.title,
        page: popURL,
        modal: true,
        classes: 'js-enable-button-after-validation',
        buttons: {},
    });
}

export function importHorse(rowObj, options) {

    if (!options.horseSexId){options.horseSexId = '';}
    if (!options.isPedigree){options.isPedigree = false;}
    if (!options.hidePedigreeOption) {options.hidePedigreeOption = false;};
    if (!options.fOnSelect){options.fOnSelect = '';}
    if (!options.ids){options.ids = '';}
    if (!options.cellPos){options.cellPos = '';}

    var popURL = 'pages/arion_import_horse.cfm?' + $.param(rowObj) + '&' + jQuery.param({
        'horseSexId': options.horseSexId,
        'isPedigree': options.isPedigree,
        'hidePedigreeOption': options.hidePedigreeOption,
        'fOnSelect': options.fOnSelect,
        'ids': options.ids,
        'cellPos': options.cellPos,
    });

    popWin({
        popID: 'arion_import_horse',
        title: 'Import Horse from Arion',
        page: popURL,
        modal: true,
        classes: 'js-enable-button-after-validation',
        buttons: {},
    });
}
